import _u from './util';
import _v from './vars';

let adLazyLoadEvent;
let inc = 0;
let lazyPos = (breakpoint == 1 ? 1122 : breakpoint == 3 ? 122 : 141);
let allPlaceHolderLoaded = false;
let cardStartIdx;
let feedLoaded = false;
let calloutLoaded = false;
let cmeGliderLoaded = false;
let confCalloutLoaded = false;
let loadedChkArr = [];
let isNonLazyInstreamAdsRendered = false;


function init() {
	inc = 0;
	delete ads2_ignore[lazyPos]; // ads2_ignore must be true on load to prevent page-loaded ad
	document.addEventListener('feedLoaded', initNonLazyInstreamAds);
	document.addEventListener('cmeGliderLoaded', initNonLazyInstreamAds);
	document.addEventListener('calloutFullyLoaded', initNonLazyInstreamAds);
	document.addEventListener('confCalloutLoaded', initNonLazyInstreamAds);	
}

function initNonLazyInstreamAds(e) { // add first 3 instream ads on first page of feed
	loadedChkArr.push(e.type);
	if (loadedChkArr.indexOf('feedLoaded') == -1 || loadedChkArr.indexOf('cmeGliderLoaded') == -1 || loadedChkArr.indexOf('calloutFullyLoaded') == -1 || loadedChkArr.indexOf('confCalloutLoaded') == -1) {
		return;
	}
	document.removeEventListener('feedLoaded', initNonLazyInstreamAds);
	document.removeEventListener('cmeGliderLoaded', initNonLazyInstreamAds);
	document.removeEventListener('calloutLoaded', initNonLazyInstreamAds);
	document.removeEventListener('confCalloutLoaded', initNonLazyInstreamAds);
	
	if (breakpoint == 1) {
		if (!isNonLazyInstreamAdsRendered) {
			_u.insertAfter(_u.strToDom('<div id="ads-pos-1122" class="AdUnit"></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[2]);
			_u.insertAfter(_u.strToDom('<div id="ads-pos-1520" class="AdUnit"></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[5]);
			_u.insertAfter(_u.strToDom('<div id="ads-pos-1420" class="AdUnit"></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[8]);
		}	
		if (typeof webmd.ads2.ads['ads-pos-1122'] == 'undefined') { // First Run
			//webmd.ads2.sizes['1520'] = [[2,3], [1,12], [300,254], [300,250], "fluid"];
			webmd.ads2.defineAd({
				id: 'ads-pos-1520',
				pos: 1520
			});		
			webmd.ads2.sizes['1122'] = [[300,250], [300,400], [300,50], [300,51], [320,50], [320,51], "fluid"];
			webmd.ads2.defineAd({
				id: 'ads-pos-1122',
				pos: 1122
			});
			webmd.ads2.sizes['1420'] = [[2,3], [1,12], [300,254], [300,250], "fluid"];
			webmd.ads2.defineAd({
				id: 'ads-pos-1420',
				pos: 1420
			});
		}
		else { // Feed Reloaded
			webmd.ads2.refresh({
				id: {
					'ads-pos-1122': true,
					'ads-pos-1520': true,
					'ads-pos-1420': true
				}
			});
		}
	} else {
		if (!isNonLazyInstreamAdsRendered) {
			_u.insertAfter(_u.strToDom('<div id="ads-pos-520" class="AdUnit"></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[2]);

			if (breakpoint != 3) {
				_u.insertAfter(_u.strToDom('<div id="ads-pos-141" class="AdUnit"></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[5]);
			} else {
				inc++;
				_u.insertAfter(_u.strToDom('<div id="ads-pos-122_1" class="AdUnit"></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[5]);
			}
			_u.insertAfter(_u.strToDom('<div id="ads-pos-420" class="AdUnit"></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[8]);
		}
		if (typeof webmd.ads2.ads['ads-pos-520'] == 'undefined') { // First Run
			webmd.ads2.sizes['520'] = [[2,3], "fluid",[400,340],[400,500],[300,255]];		
			webmd.ads2.defineAd({
				id: 'ads-pos-520',
				pos: 520
			});
			if (breakpoint != 3) {
				webmd.ads2.defineAd({
					id: 'ads-pos-141',
					pos: 141
				});
			} else {
				webmd.ads2.defineAd({
					id: 'ads-pos-122_1',
					pos: 122
				});			
			}
			webmd.ads2.sizes['420'] = [[2,3], "fluid",[300,255]];
			webmd.ads2.defineAd({
				id: 'ads-pos-420',
				pos: 420
			});
		}
		else { // Feed Reloaded
			webmd.ads2.refresh({
				id: {
					'ads-pos-520': true,
					'ads-pos-420': true,
					'ads-pos-141': true,
					'ads-pos-122_1': true
				}
			});
		}
	}
	if (!isNonLazyInstreamAdsRendered) {
		isNonLazyInstreamAdsRendered = true;
		initLazyAds(); // init lazy ads after non-lazy ads added
	}
}

function initLazyAds() {
	incrementLogic(); // check for lazy positions on first page
	document.addEventListener('feedLoaded', incrementLogic); // check lazy positions for each subsequent page
	window.addEventListener('scroll', lazyScrollHandler);
	document.addEventListener('feedDone', function() {
		allPlaceHolderLoaded = true;
	});
}

function lazyScrollHandler() { // lazy scroll debounce
	clearTimeout(adLazyLoadEvent);
	adLazyLoadEvent = setTimeout(fireLazyLoadAds, 250);
}

function incrementLogic() {

	let lastInStreamPos = document.querySelectorAll('.left-rail div[id*=ads-pos-]');
	lastInStreamPos = lastInStreamPos[lastInStreamPos.length - 1];
	cardStartIdx = _u.getIndex(lastInStreamPos) - document.querySelectorAll('.left-rail div[id*=ads-pos-]').length + 4; // start after last instream ad position, and exclude ads from being counted
		
	for (let i = cardStartIdx; i < _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item').length; i++) { // scan cards for multiple of 3, from start-index through end of cards
		if ((i + 1) % 3 == 0) {
			let j = ++inc;
			let pos = lazyPos + "_" + j;
			_u.insertAfter(_u.strToDom('<div id="ads-pos-' + pos + '" class="pending" data-index="' + j + '" ></div>'), _u.qS('.pers-feed-item,.cme-glider-container,.pers-article-item')[i]);
		}
	}	
}

function fireLazyLoadAds() {
	let slots = document.querySelectorAll('div[id*="ads-pos-' + lazyPos + '"].pending');
	if (slots.length == 0 && allPlaceHolderLoaded) { // when feed is exhausted, unbind scroll handler
		window.removeEventListener('scroll', lazyScrollHandler);
	}
	slots.forEach(function(elem, i) {
		let divElem = elem.previousElementSibling; // Use previous sibling as scroll position load-trigger
		if (scrollIntoView(divElem)) {
			elem.classList.remove('pending');
			elem.classList.add('AdUnit');
			googletag.pubads().updateCorrelator();
			if (typeof webmd.ads2.ads[elem.getAttribute('id')] == 'undefined') { // First Run
				webmd.ads2.defineAd({
					id: elem.getAttribute('id'),
					pos: lazyPos
				});	
			}
			let dfpObj = {};
			dfpObj[elem.getAttribute('id')] = true;
			webmd.ads2.refresh({
				id: dfpObj
			});
		}
	});
}

function scrollIntoView(elem) {
	return (elem.offsetParent != null && elem.getBoundingClientRect().top < window.innerHeight && elem.getBoundingClientRect().bottom >= 0);
}

init();